<div class="labels">
  <!-- `Tag` is already in VOLTA_ICONS for the inbox bulk-action bar; reusing it keeps
       the registry untouched. -->
  <ui-page-header *ngIf="!embedded" [title]="'settings.labels' | translate" [lucideIcon]="'Tag'">
    <ui-button
      type="primary"
      [label]="('settings.label' | translate | uppercase)"
      icon="plus-cc"
      iconSize="large"
      iconPosition="start"
      (click)="editLabel()"></ui-button>
  </ui-page-header>

  <!-- Embedded, the host page owns the title, so this screen states its own
       purpose the way the Connections tab beside it does. -->
  <p class="labels__description-line" *ngIf="embedded">
    {{ 'settings.labels_description' | translate }}
  </p>

  <!-- Search, count and Create on ONE row. The create button used to sit in a
       row of its own above the search, which left a band of empty space and put
       the primary action furthest from the thing it acts on. -->
  <div class="labels__toolbar">
    <ui-form-field
      class="labels__search"
      [formControl]="searchControl"
      [suffixIcon]="'search_icon'"
      [placeholder]="'settings.search_label_name' | translate">
    </ui-form-field>

    <ng-container *ngIf="filteredLabels$ | async as filtered">
      <span class="labels__result-count">{{ filtered.length }} {{ 'settings.labels' | translate | lowercase }}</span>
    </ng-container>

    <ui-button
      *ngIf="embedded"
      type="primary"
      [label]="('settings.label' | translate | uppercase)"
      icon="plus-cc"
      iconSize="large"
      iconPosition="start"
      (click)="editLabel()"></ui-button>
  </div>

  <div class="labels__card">
    <div class="labels__table-wrapper">
      <table class="labels__table">
        <thead>
          <tr class="labels__table-head">
            <th class="labels__col--swatch-head"></th>
            <th>{{ 'settings.label_name' | translate }}</th>
            <th>{{ 'settings.label_origin' | translate }}</th>
            <th>{{ 'settings.label_visible' | translate }}</th>
            <th>{{ 'settings.label_eligible' | translate }}</th>
            <th class="labels__col--actions-head"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let label of filteredLabels$ | async; trackBy: trackByLabelId">
            <tr class="labels__row">
              <td class="labels__col--swatch">
                <span class="labels__swatch" [style.background]="label.color"></span>
              </td>

              <td class="labels__col--label">
                <span class="labels__name">
                  {{ label.name }}
                </span>
                <!-- Where a seeded label came from, and the tenant's own description,
                     on the one line. Both can be present: the seeder never writes a
                     description, but PATCH lets a tenant add one later, and dropping
                     either would hide something the user put there or something only
                     the server knows. -->
                <!-- One lookup per row: seededFromKey feeds the note, the separator and the fallback. -->
                <span class="labels__description" *ngIf="{ key: seededFromKey(label) } as seeded">
                  <span class="labels__seeded-from" *ngIf="seeded.key">
                    {{ seeded.key | translate }}
                  </span><span *ngIf="seeded.key && label.description" class="labels__description-sep"> · </span>{{ label.description || (seeded.key ? '' : emptyStateValue) }}
                </span>
              </td>

              <td class="labels__col--origin">
                <span class="labels__origin labels__origin--{{ originClass(label) }}">
                  {{ originLabelKey(label) | translate }}
                </span>
              </td>

              <td class="labels__col--flag">
                <span class="labels__flag" [class.labels__flag--on]="label.visible">
                  {{ (label.visible ? 'common.yes' : 'common.no') | translate }}
                </span>
              </td>

              <td class="labels__col--flag">
                <span class="labels__flag" [class.labels__flag--on]="label.eligible">
                  {{ (label.eligible ? 'common.yes' : 'common.no') | translate }}
                </span>
              </td>

              <td class="labels__col--actions" (click)="$event.stopPropagation()">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="labelMenu"
                  class="labels__actions-btn"
                  [attr.aria-label]="'common.actions' | translate">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #labelMenu="matMenu" xPosition="before" panelClass="ui-action-menu">
                  <button mat-menu-item class="ui-action-menu-item" (click)="editLabel(label)">
                    <span class="ui-action-menu-item__icon">
                      <ui-svg-icon svgIcon="pen-cc"></ui-svg-icon>
                    </span>
                    <span class="ui-action-menu-item__label">{{ 'common.edit' | translate }}</span>
                  </button>
                  <button
                    mat-menu-item
                    class="ui-action-menu-item ui-action-menu-item--danger"
                    (click)="deleteLabel(label)">
                    <span class="ui-action-menu-item__icon">
                      <ui-svg-icon svgIcon="trash-cc"></ui-svg-icon>
                    </span>
                    <span class="ui-action-menu-item__label">{{ 'common.delete' | translate }}</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <!-- CRUD-03. The backend answers an empty tenant with 200 + data: [], so there is
           nothing to handle here — only something to render. Gated on the loader so it
           does not flash before the first response lands. Also covers a search that
           matched nothing, which is a different sentence. -->
      <div class="labels__empty" *ngIf="!(filteredLabels$ | async)?.length && (loading$ | async) === false">
        {{ (hasSearchTerm ? 'settings.no_labels_found' : 'settings.no_labels') | translate }}
      </div>
    </div>
  </div>
</div>
